'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _BaseIcon2 = require('./BaseIcon');

var _BaseIcon3 = _interopRequireDefault(_BaseIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
var TestUser = function (_BaseIcon) {
  (0, _inherits3.default)(TestUser, _BaseIcon);

  function TestUser() {
    (0, _classCallCheck3.default)(this, TestUser);
    return (0, _possibleConstructorReturn3.default)(this, (TestUser.__proto__ || (0, _getPrototypeOf2.default)(TestUser)).apply(this, arguments));
  }

  (0, _createClass3.default)(TestUser, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'svg',
        this.getSvgProps(),
        _react2.default.createElement('path', (0, _extends3.default)({ d: 'M20.873 14.742c1.873 1.05 1.883 2.07 1.883 2.07v2.176H20.53l.343-4.246zm-17.228 4.25H1.45v-2.18s.01-1.01 1.86-2.057l.335 4.236zm5.748-8.112c-.405-.68-.763-1.516-1.133-2.45-.327-.827-.272-1.533-.272-2.536 0-.738-.14-1.923.043-2.574C8.654 1.11 10.23.5 12.08.5c1.846 0 3.422.61 4.046 2.814.184.652.044 1.84.044 2.58 0 1 .056 1.705-.27 2.53-.37.934-.732 1.773-1.142 2.456H9.393zM3.9 12.493c-.04-.546.368-.99.923-.99h14.55c.55 0 .962.453.92.99l-.66 8.534c-.043.546-.524.99-1.08.99H5.623c-.553 0-1.037-.453-1.077-.99L3.9 12.493zM18.36 22.7H5.564c-.125 0-.226.153-.226.342 0 .19.1.342.226.342H18.36c.125 0 .226-.153.226-.342 0-.19-.1-.342-.226-.342z' }, this.getPathProps()))
      );
    }
  }]);
  return TestUser;
}(_BaseIcon3.default);
/*eslint-enable */


TestUser.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 24 24'
};
exports.default = TestUser;
//# sourceMappingURL=TestUser.js.map


//////////////////
// WEBPACK FOOTER
// ../icon/lib/Icons/TestUser.js
// module id = 327
// module chunks = 0